/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { OrderCopyCompany } from './order_copy_company'
import type { OrderCopyContact } from './order_copy_contact'
/**
 * Данные партнёра
 */
export type OrderCopyPartner = {
  /**
   * Пользователь сам, как физ.лицо или представитель заказчика юр.лица
   */
  isUser: boolean
  /**
   * Тип партнёра
   */
  type: OrderCopyPartner.type
  /**
   * Компания (юр. лицо). Обязательно при type=Legal, не указывается при type=Individual
   */
  company: null | OrderCopyCompany
  /**
   * Контакт (физ. лицо). Обязательно при любом значении type
   */
  contact: null | OrderCopyContact
}
export namespace OrderCopyPartner {
  /**
   * Тип партнёра
   */
  export enum type {
    LEGAL = 'legal',
    INDIVIDUAL = 'individual'
  }
}
